import { Pipe, PipeTransform } from '@angular/core';
import * as accounting from 'accounting';
import * as g from 'src/app/globals';

@Pipe({
  name: 'price',
})
export class PricePipe implements PipeTransform {
  transform(value: any, currency: string): unknown {
    const companyConfiguration = g.companyConfiguration;
    if (companyConfiguration == null) {
      return value;
    }
    if (value === null || isNaN(value)) {
      value = 0;
    }

    const returnValue = accounting.formatNumber(
      value,
      companyConfiguration.AmountDecimal,
      companyConfiguration.ThousandSep,
      companyConfiguration.DecimalSep
    );

    return (
      (!companyConfiguration.CurrencyOnRight ? currency + ' ' : '') +
      returnValue +
      (companyConfiguration.CurrencyOnRight ? ' ' + currency : '')
    );
  }
}
